export const detailsStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  padding: '12px 16px 16px',
  backgroundColor: ({ palette }) => palette.background.secondary,
};
